module.exports = __webpack_public_path__ + "img/status.0196f36d.png";